/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Options } from 'react-lottie';
import favoriteAnimation from 'assets/animations/favourite_app_icon.json';
import { useDispatch, useSelector } from 'react-redux';
import { createFavorite, destroyFavorite } from 'store/modules/bidding_store/actions';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import {
  createFavoriteImminance,
  destroyFavoriteImminance,
} from 'store/modules/get_dados_imminence_store/actions';
import {
  createFavoriteBulletin,
  destroyFavoriteBulletin,
} from 'store/modules/bulletins_store/actions';
import tabId from 'services/tabId';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { Container, LottieWrapper, Favorite } from './styles';

const animationLoopOptions = {
  loop: false,
  goAndStop: true,
  goAndPlay: false,
  isPaused: false,
  autoplay: false,
  isStopped: true,
  startAt: 0,
  animationData: favoriteAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface FavoriteButtonProps {
  biddingId: string;
  isFavorited: boolean;
  favoritedSource: string;
  bulletinFilterId?: number;
  source: string;
  contactList?: Array<any>;
}

const FavoriteButton = (props: FavoriteButtonProps) => {
  const {
    biddingId,
    isFavorited,
    favoritedSource,
    bulletinFilterId = 0,
    source,
    contactList,
  } = props;

  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [animationOptions, setAnimationOptions] = useState<Object>(animationLoopOptions);
  const [isExpectingAnimation, setIsExpectingAnimation] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const setAnimation = () => {
    const animationState = { ...animationLoopOptions };

    if (isFavorited) {
      animationState.goAndStop = !isExpectingAnimation;
      animationState.goAndPlay = !!isExpectingAnimation;
      animationState.isStopped = false;
      animationState.startAt = isExpectingAnimation ? 0 : 60;
    }

    setAnimationOptions(animationState);
  };

  useEffect(() => {
    setAnimation();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [isFavorited]);

  const contactName = profile.contact_name || profile.name;

  const toggleFavorite = () => {
    if (loading) return;
    setLoading(true);
    if (!isFavorited && favoritedSource === 'bidding') {
      dispatch(createFavorite(biddingId, contactName, profile?.currentCompany[tabId()]));

      source === 'favorited'
        ? createTrack('Card - Favoritou', { fonte: source })
        : createTrack('Card - Favoritou', { fonte: favoritedSource });
      track('licitacao.favoritou', { bidding_id: biddingId, fonte: favoritedSource });
    }

    if (isFavorited && favoritedSource === 'bidding') {
      dispatch(destroyFavorite(biddingId, contactName, profile?.currentCompany[tabId()]));

      source === 'favorited'
        ? createTrack('Card - Desfavoritou', { fonte: source })
        : createTrack('Card - Desfavoritou', { fonte: favoritedSource });
    }

    if (!isFavorited && favoritedSource === 'imminence') {
      dispatch(createFavoriteImminance(biddingId, profile.name, profile?.currentCompany[tabId()]));
      createTrack('Card - Favoritou', { fonte: favoritedSource });
      track('licitacao.favoritou', { bidding_id: biddingId, fonte: favoritedSource });
    }
    if (isFavorited && favoritedSource === 'imminence') {
      dispatch(destroyFavoriteImminance(biddingId, profile.name, profile?.currentCompany[tabId()]));
      createTrack('Card - Desfavoritou', { fonte: favoritedSource });
    }

    if (!isFavorited && favoritedSource === 'bulletin') {
      dispatch(
        createFavoriteBulletin(
          biddingId,
          profile.name,
          bulletinFilterId,
          profile?.currentCompany[tabId()],
        ),
      );
      createTrack('Card - Favoritou', { fonte: favoritedSource });
      track('licitacao.favoritou', { bidding_id: biddingId, fonte: favoritedSource });
    }
    if (isFavorited && favoritedSource === 'bulletin') {
      dispatch(
        destroyFavoriteBulletin(
          biddingId,
          profile.name,
          bulletinFilterId,
          profile?.currentCompany[tabId()],
        ),
      );
      createTrack('Card - Desfavoritou', { fonte: favoritedSource });
    }

    setIsExpectingAnimation(false);
    setAnimation();
  };

  const afterAnimation = () => {
    setIsExpectingAnimation(false);
    // setAnimation(); - dá loop infinito ç-ç
  };
  return (
    <Favorite
      isFavorited={!!contactList?.length}
      className="position-relative databalloon mr-2"
      aria-label={
        contactList?.length
          ? `${contactList.join('\n')}`
          : 'Adicionar licitação em Gerenciar Licitações'
      }
      data-balloon-pos="up"
      data-balloon-length="medium"
    >
      <Container
        className="bidding-item-header-button hover-pointer bidding-favorited-icon"
        onClick={() => toggleFavorite()}
      >
        <div>
          <LottieWrapper
            style={{ height: '42px' }}
            isStopped={!isFavorited}
            options={animationOptions as Options}
            eventListeners={[
              {
                eventName: 'complete',
                callback: () => afterAnimation(),
              },
            ]}
          />
        </div>

        {isFavorited}
      </Container>
      {contactList?.length && contactList?.length > 0 && (
        <span className="text-white ml-1">{contactList?.length}</span>
      )}
    </Favorite>
  );
};

export default FavoriteButton;
